module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Medium.5a83549d.ttf";